import React from 'react';
import { useTranslation } from 'react-i18next';
import PokerCard from './PokerCard';

export const orderMatchPlayers = (players, playerId) => [...players].sort((a, b) =>
    Number(b.playerId === playerId) - Number(a.playerId === playerId));

export default function ShowedCardsResultRow({ upper, lower }) {
    const { t } = useTranslation();
    return <div className="declared-cards-wrapper showed-card-results">
        <div><span>{t('gameSettings.upperShowCard')}</span><PokerCard card={upper} isShowType /></div>
        <div><span>{t('gameSettings.lowerShowCard')}</span><PokerCard card={lower} isShowType /></div>
    </div>;
}
